module.exports = __webpack_public_path__ + "static/media/tripwire.3bf7502a.jpeg";